import breadcrumb from "#templates/pages/breadcrumb";
import language from "#scripts/translation";
import { doSearch } from "#scripts/search_haive.js";

export default function (val) {
  const searchOn = val.trim();
  const breadcrumbHtml = breadcrumb();

  document.title = language("SEARCH_TITLE");

  doSearch(searchOn);
  return `
        <div class="container p-md-0">
            ${breadcrumbHtml}
        </div>
        <div class="container p-md-0">
          <div class="row xjustify-content-md-center xcol-12 no-gutters" style="">
                  <div class="searchheader">
                      <div class="container">
                          <div class="row no-gutters">
                              <h1 class="col-12 col-md-3 searchheader__input-title">${language("SEARCH_TITLE")}</h1>
                              <div class="col-12 col-md-7 searchheader__input-group">
                              <xform class="header__search__container" role="search" autocomplete="off">
                                <input type="search" class="input-control header__search__input is-active searchheader__inputfield" id="searchheader__inputfield" placeholder="${language(
    "SEARCH_INPUT",
  )}" value="" autocomplete="off">
                                <button class="searchheader__search-button header__button__dosearch" id="searchheader__button" type="button">
                                  <span class="material-icons-outlined notranslate header__icon">&#xE8B6;</span>
                                </button>
                              </form>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="row searchcontent no-gutters">
                      <div class="col-12 col-md-1" id="leftCol" style="display:none;">
                        <div class="categories">
                          <div class="categories__header">
                            <div class="categories__headertitle">
                              <a href="#" class="categories__headerlink">${language("SEARCH_FILTERHEADER")}</a>
                            </div>
                          </div>
                          <div class="categories__selected"></div>
                          <div class="categories__list">
                            <div class="categories__collection"></div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-9 col-lg-7" id="mainCol">
                          <div class="searchresult__header">
                              <div class="searchresult__meta">
                                  <div class="row">
                                      <div class="col-12 col-md-5 col-lg-7">
                                          <div id="resultscount" class="searchresult__meta__count" role="status"></div>
                                      </div>
                                      <div class="col-12 col-md-7 col-lg-5 p-0 no-gutters">
                                          <div class="dropdown searchresult__meta__dropdown__container">
                                              <label class="searchresult__meta__label">${language("SEARCH_SORTBY")}</label>
                                              <div class="searchresult__meta__dropdown">
                                                <button class="btn btn-default dropdown-toggle pull-right searchresult__meta__dropdown-button" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                                    <span class="btn-text searchresult__meta__choosedtxt">${language("SEARCH_RELEVANCE")}</span>
                                                    <span class="icon material-icons-outlined notranslate">&#xe5cf</span>
                                                </button>
                                                <ul class="dropdown-menu dropdown-menu-right searchresult__meta__dropdown-content" aria-labelledby="dropdownMenu1">
                                                    <li><a href="#" data-order="Relevance" class="searchresult__meta__choice dropdown-item">${language("SEARCH_RELEVANCE")}</a></li>
                                                    <li><a href="#" data-order="Date" class="searchresult__meta__choice dropdown-item">${language("SEARCH_DATE")}</a></li>
                                                </ul>
                                              </div>
                                          </div>

                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="searchresult">
                          
                              <div class="lds-ellipsis black"><div></div><div></div><div></div><div></div></div>
                              <div class="searchresult__filter"></div>
                              <div class="">
                                  <div class="searchresult__list list-unstyled"></div>
                              </div>
                              <div class="searchresult__footer"><div class="searchresult__pagination"></div></div>
                          </div>
                      </div>
                  </div>
                </div>
            </div>`;
}
